import ApiService from '../api/ApiService';

export default async function postRecord(record, client = 'carcheck') {
  const rawResponse = await ApiService('postRecord', { client }, null, JSON.stringify(record));
  return rawResponse.data;
}
